<template>
  <div style='height: 100vh;'>
    <FillStep />
    <div class='fill-warp' >
      <van-form >
          <van-form v-for='(studyItem, index) in studyExp' :key='index' ref='educationForm'>
            <van-field
            required
            readonly
            clickable
            name="picker"
            :value="studyItem.level"
            label="学历"
            placeholder="请选择学历"
            @click="levelClick(index)"
            :rules="[{ required: true, message: '请选择学历' }]"
          />
          <van-popup v-model="edutionPicker"  position="bottom">
            <van-picker
              show-toolbar
              :columns="educationSelect"
              @confirm="levelConfirm"
              @cancel="edutionPicker = false"
            />
          </van-popup>
          <van-field
          required
            @click='studyClick(index)'
            v-model="studyItem.school_name"
            clearable
            name="毕业院校"
            label="毕业院校"
            placeholder="请输入院校"
            :rules="[{ required: true, message: '请输入院校' }]"
          />
          <van-field
          required
            @click='studyClick(index)'
            v-model="studyItem.major"
            clearable
            name="所学专业"
            label="所学专业"
            placeholder="请输入专业"
            :rules="[{ required: true, message: '请输入专业' }]"
          />
          <van-field
          required
            readonly
            clickable
            name="datetimePicker"
            :value="studyItem.graduation_time"
            label="毕业时间"
            placeholder="点击选择毕业时间"
            :rules="[{ required: true, message: '请选择毕业时间' }]"
            @click="graduationClick(index)"
          />
          <van-popup v-model="graduationTimeShowPicker" position="bottom">
            <van-datetime-picker
              :min-date="minDate"
              type="year-month"
              v-model="currentDate"
              @confirm="graduationConfirm"
              @cancel="graduationTimeShowPicker = false"
            />
          </van-popup>
          <van-field required name="radio" label="是否统招" @click='studyClick(index)'>
            <template #input>
              <van-radio-group v-model="studyItem.isAllday" checked-color='#edad57' direction="horizontal" >
                <van-radio name="1">是</van-radio>
                <van-radio name="2">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-if='studyExp.length <= 1 && index === 0' style='margin:16px'></div>
          <div v-else class="del-btn">
            <van-button color='#f8bb5b'  icon="delete-o" size='small'   @click="deleteInfo('study',index)">删除</van-button>
          </div>
          </van-form>
          <div  class='btn-sty'>
            <van-button plain block icon="plus"  v-if='studyExp.length < 2 ' @click="addStudyInfo">添加学习经历</van-button>
          </div>
        
        <van-form v-for='(trainItem, trainIndex) in train' :key='trainIndex+2' >
          <van-field
            @click='studyClick(trainIndex)'
            v-model="trainItem.train_name"
            clearable
            name="培训机构"
            label="培训机构"
            placeholder="请输入培训学校"
          />
          <van-field
            @click='studyClick(trainIndex)'
            v-model="trainItem.train_content"
            clearable
            name="培训内容"
            label="培训内容"
            placeholder="请输入培训内容"
          />
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="trainItem.train_time"
            label="培训时间"
            placeholder="点击选择毕业时间"
            @click="trainClick(trainIndex)"
          />
          <van-popup v-model="trainTimeShowPicker" position="bottom">
            <van-datetime-picker
              :min-date="minDate"
              type="year-month"
              v-model="currentDate"
              @confirm="trainConfirm"
              @cancel="trainTimeShowPicker = false"
            />
          </van-popup>
          <van-field
            @click='studyClick(trainIndex)'
            v-model="trainItem.train_certificate"
            clearable
            name="培训证书"
            label="培训证书"
            placeholder="请输入证书名称"
          />
          <div v-if='train.length == 1 && trainIndex == 0 '  style='margin:16px;'></div>
          <!-- <div v-else class="del-btn">
            <van-button color='#f8bb5b'  icon="delete-o" size='small'  @click="deleteInfo('train',trainIndex)">删除</van-button>
          </div> -->
        </van-form>
        <!-- <div class='btn-sty'>
            <van-button plain block  icon="plus" v-if='train.length < 2 ' @click="addTrainInfo">添加培训经历</van-button>
          </div> -->
        <div style="margin: 80px 16px 16px 16px;">
          <van-button style='font-size:16px; border-radius:5px;'  block type="info" color='#E39E54'  @click="nextStep">下一步</van-button>
        </div>
      </van-form>
      
    </div>
  </div>
</template>

<script>
import FillStep from "../userRegistration/comp/fillStep";
import { mapState, mapMutations } from "vuex";
import moment from "moment"
import { urlAddParams } from '@/utils/tool';
  export default {
    name:'education',
    data() {
      return {
        studyExp: [
          {
          level:'',
          school_name:'',
          major:'',
          graduation_time:'',
          isAllday:'1',
        }
        ],
        train: [
          {
            train_name:'',
            train_content:'',
            train_time: '',
            train_certificate:''
          }
        ],
        currentDate: new Date(2015,5,1),
        currentIndex: 0,
        edutionPicker: false,
        educationSelect:['初中及以下','高中','中专/中技','大专','本科', '硕士', 'MBA/EMBA', '博士'],
        minDate: new Date(1970, 0, 1),
        graduationTimeShowPicker: false,
        trainTimeShowPicker: false
      }
    },
    beforeRouteLeave(to, from, next){
      if(!this.isFillInfo()){
          this.$toast({
              message: "请至少填写一段学习经历！",
              icon:'warning-o',
              duration: 2500
            })
          return
      }else{
        localStorage.setItem('education', JSON.stringify( Object.assign({}, {"studyExp": this.studyExp}, {"train": this.train}) ))
        next()
      }
        
    },
    components:{
      FillStep
    },
    computed:{
      ...mapState([ "education" ]),
    },
    mounted() {
      window.scrollTo(0,0)
      let data = JSON.parse(localStorage.getItem('education'))
      if(data != null){
        this.studyExp = data.studyExp;
        this.train = data.train;
      }
    },
    methods:{
      ...mapMutations([ "SET_EDUTION_INFO" ]),
      //使用  this.SET_BASE_INFO(data)
      isFillInfo(){
        let flag = false;
        if(this.studyExp[0].level == '' || this.studyExp[0].school_name == '' || this.studyExp[0].major == '' || this.studyExp[0].graduation_time == '' ){
          flag = false
        }else{
          flag = true
        }
        return flag
      },
      levelClick(val){
        this.edutionPicker = true;
        this.currentIndex = val;
      },
      graduationClick(val) {
        this.graduationTimeShowPicker = true;
        this.currentIndex = val;
      },
      levelConfirm(val) {
        this.studyExp[this.currentIndex].level = val;
        this.edutionPicker = false;
      },
      graduationConfirm(val) {
        this.studyExp[this.currentIndex].graduation_time = moment(val).format("YYYY-MM");
        this.graduationTimeShowPicker = false;
      },
      trainClick(val){
        this.trainTimeShowPicker = true;
        this.currentIndex = val;
      },
      trainConfirm(val){
        this.train[this.currentIndex].train_time = moment(val).format("YYYY-MM");
        this.trainTimeShowPicker = false;
      },
      studyClick(index){
        this.currentIndex = index;
      },
      addStudyInfo() {
        this.studyExp.push({
          level:'',
          school_name:'',
          major:'',
          graduation_time:'',
          isAllday:'1',
        })
        this.currentIndex = this.studyExp.length - 1;
      },
      addTrainInfo() {
        this.train.push({
            train_name:'',
            train_content:'',
            train_time: '',
            train_certificate:''
          })
        this.currentIndex = this.train.length - 1;
      },
      nextStep(){
        if(!this.isFillInfo()){
            this.$toast({
                message: "请至少填写一段学习经历！",
                icon:'warning-o',
                duration: 2500
              })
            return
        }
        let tmpObj = Object.assign({}, {"studyExp": this.studyExp}, {"train": this.train})
        this.SET_EDUTION_INFO(tmpObj)
        const path = urlAddParams('/workExperience', this.$route.query);
        this.$router.replace(path);
      },
      deleteInfo(type,index){
        if(type == 'study'){
          this.studyExp.splice(index, 1)
        }else{
          this.train.splice(index, 1)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
@import "../../assets/css/page.css";
.btn-sty{
  margin: 16px;
  color:#E39E54;
  .van-button{
    background: #FFECD8;
    color:#E39E54;
  }
  border-radius: 4px;
}

</style>
